import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scora-modal-module',
  templateUrl: './scora-modal-module.component.html',
  styleUrls: ['./scora-modal-module.component.css']
})
export class ScoraModalModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/scora-modal-module.component.ts